import { render, staticRenderFns } from "./wages-table.view.vue?vue&type=template&id=aec89c56&scoped=true&"
import script from "./wages-table.view.vue?vue&type=script&lang=ts&"
export * from "./wages-table.view.vue?vue&type=script&lang=ts&"
import style0 from "./wages-table.view.vue?vue&type=style&index=0&id=aec89c56&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec89c56",
  null
  
)

export default component.exports